window.anvil.component('pagination', el => {
    el.querySelectorAll('.js-toggler').forEach(e => e.addEventListener('click', () => e.focus()));
});
